import { render, staticRenderFns } from "./Bca.vue?vue&type=template&id=6a77dea8&scoped=true&"
import script from "./Bca.vue?vue&type=script&lang=js&"
export * from "./Bca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a77dea8",
  null
  
)

export default component.exports